import { Heart } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { TierPicker } from "@/components/TierPicker";

export default function Support() {
  const [searchParams] = useSearchParams();
  const isSuccess = searchParams.get('success') === 'true';
  const isCancelled = searchParams.get('cancelled') === 'true';

  return (
    <div className="min-h-screen bg-background">
      {/* Hero with photo — matching landing pattern */}
      <div className="relative overflow-hidden py-10 md:py-24 px-4 text-center text-white">
        <div className="absolute inset-0 bg-gradient-to-br from-[hsl(260,75%,22%)] via-[hsl(235,75%,30%)] to-[hsl(210,80%,25%)]" />
        <div className="absolute inset-0 z-[1]">
          <img
            src="/images/events/autumn-team-thumbs-up-sm.webp"
            alt=""
            className="w-full h-full object-cover opacity-[0.15]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[hsl(260,75%,22%,0.9)] via-[hsl(235,75%,30%,0.7)] to-transparent" />
        </div>
        <div className="relative z-10">
          <Heart className="w-8 h-8 mx-auto mb-3 opacity-80" />
          <h1 className="text-2xl font-black mb-2">You Make This Possible</h1>
          <p className="text-sm leading-relaxed opacity-80 max-w-sm mx-auto">
            Your support fuels everything behind the scenes — from crafting
            questions and building the platform to bringing Quizrun to new cities.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-10 max-w-lg">
        {/* Success / cancelled banners */}
        {isSuccess && (
          <div className="mb-6 p-4 rounded-xl bg-green-500/10 border border-green-500/30 text-green-700 dark:text-green-400 text-sm text-center">
            🎉 Thank you so much! Your support means the world to us.
          </div>
        )}
        {isCancelled && (
          <div className="mb-6 p-4 rounded-xl bg-muted border text-muted-foreground text-sm text-center">
            No worries — your support page is still here if you change your mind. 💙
          </div>
        )}

        <TierPicker />
      </div>
    </div>
  );
}
